import { Outlet, useLocation } from 'react-router-dom';

import { cn } from '@/shared/utils';

import { ScrollArea } from '@/components/ui/scroll-area';

import Footer from './ui/footer';
import Navbar from './ui/navbar';

const Layout = () => {
  const location = useLocation();
  const isLivescoringPage = location.pathname.includes('/livescoring');

  return (
    <ScrollArea className="h-screen">
      <Navbar />

      <main
        className={cn(
          'relative min-h-[calc(100vh-97px)]',
          'md:min-h-[calc(100vh-65px)] pb-[50px]',
          isLivescoringPage
            ? 'pt-[135px] min-[510px]:pt-20 xl:pt-navbar-desktop'
            : 'pt-[107px] md:pt-[65px] xl:pt-navbar-desktop'
        )}
      >
        <Outlet />
        <div
          className={cn(
            'fixed bottom-0 left-0 right-0 top-0',
            'bg-gradient-to-b from-black to-[#2D623B]',
            'z-[-1] h-screen'
          )}
        />
      </main>

      <Footer />
    </ScrollArea>
  );
};

export default Layout;
